export const COMMERCIAL_PROPERTY_TYPES = [
  'Single Family',
  '2-4 Units',
  'Condo',
  'PUD',
  'Mixed-Use',
  '(5-9 units)',
  '(10+ units)',
  'Land',
  'Other',
] as const;

export const OWNERSHIP_OPTIONS = ['Own', 'Rent'] as const;

export const OWNED_RENTED_YEARS = [
  '< 1 year',
  '1-2 years',
  '2-5 years',
  '5+ years',
] as const;

export const ENTITY_TYPES = [
  'Corporation',
  'LLC',
  'Limited Partnership',
  'LLP',
  'S Corporation',
  'C Corporation',
  'Partnership',
  'Other',
] as const;

export const MARITAL_STATUS_OPTIONS = [
  'Married',
  'Unmarried',
  'Separated',
] as const;

export const TRACK_RECORD_PROPERTY_TYPES = [
  'SRF',
  'Condo',
  '2-4 Units',
  'PUD',
  '(5-9 units)',
  '(10+ units)',
  'Mixed-Use',
  'Land',
  'Other',
] as const;
